import $ from 'jquery';
import {toggleItem} from './toggle.js';
import '../css/scss/4-objects/_main-menu.scss';
import '../css/scss/4-objects/_utility-nav.scss';

(() => {
  $(document).ready(function() {
    // Slide up any Footer Nav items
    $('.footer-nav').slideUp();
    // Call function to allow toggling of the menu
    toggleItem();
  });
})();



// WEBPACK FOOTER //
// ./resources/js/menu.js